module.exports = require("core-js/es6/promise");